import React from "react";
import PriceSetting from "./PriceSetting";
import {Button, Form} from "react-bootstrap";
import {csrfParam, csrfToken} from "./lib/utils";

export default class PriceSettings extends React.Component {
    constructor(props) {
        super(props);
        let data = JSON.parse(props.data || '{prices:[], market:""}');
        let {prices, settings} = data;
        console.log(data);
        if (settings && prices === undefined) {
            data = settings[0] || {};
            prices = data?.prices || [];
            data.prices = prices;
        }
        console.log(prices);
        if (prices.length === 0) {
            prices.push({});
        }
        this.state = Object.assign({}, data);
        console.log(this.props.data);
    }

    handleChange = (rowData, i) => {
        const prices = this.state.prices.slice();
        prices[i] = rowData;
        this.setState({prices});
    };

    onDelete = (index) => {
        const prices = this.state.prices.slice();
        prices.splice(index, 1);
        this.setState({prices});
    };

    addPriceSetting = (e) => {
        e.preventDefault();
        const prices = this.state.prices.slice();
        prices.push({});
        this.setState({prices});
        return false;
    };

    render() {
        return <Form validated={true} id="price-settings-form" action={this.props.url} method='POST' data-remote={true}>
            <input name='_method' type='hidden' value={this.props.action}/>
            <input type='hidden' name={csrfParam()} value={csrfToken()} />
            <ul>
                {
                    this.state.prices.map((props, i) =>
                        <li key={`price-setting-${i}`}><PriceSetting {...props} onChange={this.handleChange} onDelete={this.onDelete} index={i} market={this.state.market}/></li>)
                }
            </ul>
            <Button variant="primary" onClick={this.addPriceSetting}>価格設定を追加</Button>
        </Form>
    };
}